export default __webpack_public_path__ + "static/live-hero-three-left-e20fcdcda77518d5e0e997615cee1c0d.webp";